import { graphql } from "../gql";

export const getClaimAuditGroupCommentsQueryDoc = graphql(`
  query AuditGroupComments($id: UUID!) {
    claimAuditGroup(id: $id) {
      id
      name
      comments {
        id
        authorId
        authorName
        body
        createdAt
      }
    }
  }
`);
